export enum System {
  ICARE = 'iCare',
}
